import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    hasLoggedIn: false,
    timeout: null,
    activeRoute: "",
    userRole: null,
    userInfo: {},
    userToken: null,
    // showLoader: false,
    // navigationSource: null,
    // popupMessage: null, // Store the message for the popup
    // showPopup: false,   // Control popup visibility
    // referenceId: null, // Current active referenceId (for compatibility)
    // pendingOrders: [], // New: Array to store all pending orders with referenceIds
    // hashId: null, // Store the text after '#'
    // isOrderDetailsClicked: false,
  },
  plugins: [
    createPersistedState({
      paths: ["hasLoggedIn","userRole", "timeout", "userInfo", "userToken"],
      // paths: ["userToken"],
    }),
  ],
  actions: {
    login({ commit }, { token }) {
      return new Promise((resolve) => {
        // Save user details and token
        // commit("setUserInfo", userInfo);
        commit("setUserToken", token);
        commit("setLoggedIn", true);
        // commit("setUserTimeout");
        resolve();
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        // Clear all user-related data
        commit("setUserRole", null);
        commit("clearUserTimeout");
        commit("setLoggedIn", false);
        commit("setUserInfo", {});
        commit("setUserToken", null);
        resolve();
      });
    },
  },
  mutations: {
    setUserRole(state, value) {
      state.userRole = value;
    },
    // setNavigationSource(state, source) {
    //   state.navigationSource = source;
    // },
    setLoggedIn(state, value) {
      state.hasLoggedIn = value;
    },
    // setActiveRoute(state, value) {
    //   state.activeRoute = value;
    // },
    setUserTimeout(state) {
      state.timeout = new Date().getTime() + 30 * 60 * 1000;
    },
    clearUserTimeout(state) {
      state.timeout = null;
    },
    setUserInfo(state, value) {
      state.userInfo = value;
    },
    setUserToken(state, value) {
      state.userToken = value;
    },
    // setShowLoader(state, value) {
    //   state.showLoader = value;
    // },
    resetCognitoInfo(state) {
      state.userInfo = {};
      state.userToken = null;
      state.hasLoggedIn = false;
      state.userRole = null;
    },
    // setPopupMessage(state, message) {
    //   state.popupMessage = message;
    //   state.showPopup = true;
    //   const afterAtText = message?.split("@")[1]?.split(" ")[0] || null;
    //   state.referenceId = afterAtText;
    //   const afterHashText = message?.split("#")[1]?.split(" ")[0] || null;
    //   state.hashId = afterHashText;
    
    //   if (afterAtText) {
    //     const exists = state.pendingOrders.some(order => order.referenceId === afterAtText);
    //     if (!exists) {
    //       state.pendingOrders.push({
    //         referenceId: afterAtText,
    //         message: message,
    //         timestamp: Date.now(),
    //       });
    //     }
    //   }
    // },
    // clearPopupMessage(state) {
    //   state.popupMessage = null;
    //   state.showPopup = false;
    //   // Optionally remove the order from pendingOrders if declined/accepted
    // },
    // setReferenceId(state, referenceId) {
    //   state.referenceId = referenceId; // Set current referenceId
    // },
    // removePendingOrder(state, referenceId) {
    //   state.pendingOrders = state.pendingOrders.filter(order => order.referenceId !== referenceId);
    // },
    // SET_ORDER_DETAILS_CLICKED(state, value) {
    //   state.isOrderDetailsClicked = value;
    // },
  },
  getters: {
    isSessionActive: (state) => {
      return state.timeout && new Date().getTime() < state.timeout;
    },
    // isOrderDetailsClicked: (state) => state.isOrderDetailsClicked,
  },
});
